import React, {useRef, useState} from 'react';
import {SafeAreaView, View, ScrollView} from 'react-native';
import Text from '../../components/elements/Text';
import VerifyCode from '../../components/modules/VerifyCode';
import BreadCrumbs from '../../components/elements/BreadCrumbs';
import makeStyles from './styles.web';
import {useTheme, useThemedStyles} from '../../theme';
import {BUTTON_TYPES, SEND_OTP_TYPES} from '../../utils/Constants';
import {getCountryCode, transformPhoneForAPI} from '../../utils/HelperMethods';
import {tID} from '../../utils/TestIdHelper';
import CommonStyles from '../../utils/CommonStyles';
import Divider from '../../components/elements/Divider';
import Button from '../../components/elements/Button';
import {LogoGroup, LeftArrowIcon} from '../../utils/SvgIcons';

const UI = ({
  navigation,
  phoneNo,
  moveToNextStep = () => {},
  authCredentials,
  isSourceApp,
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const codeInputRef = useRef();
  const [code, setCode] = useState('');

  const handleCodeChange = val => setCode(val);

  return (
    <SafeAreaView
      testID={tID('PhoneVerificationSignup-SafeAreaView-Main')}
      style={styles.maincontainer}>
      <ScrollView
        testID={tID('PhoneVerificationSignup-ScrollView-1')}
        style={styles.formView}>
        <LogoGroup width={146} height={40} style={CommonStyles.mv_40} />
        <View
          testID={tID('PhoneVerificationSignup-View-SigninRouteContainer')}
          style={styles.signinRouteContainer}>
          <LeftArrowIcon width={5} height={9} tintColor={colors.textDisabled} />
          <Text
            testID={tID('PhoneVerificationSignup-Text-SigninRoute')}
            variation="Text1SemiBold"
            color={colors.textDisabled}
            lineHeight={21}
            style={CommonStyles.mh_12}>
            Sign-In
          </Text>
          <LeftArrowIcon
            width={5}
            height={9}
            tintColor={colors.link}
          />
          <Text
            testID={tID('PhoneVerificationSignup-Text-PersonalDetails')}
            variation="Text1SemiBold"
            color={colors.link}
            lineHeight={21}
            style={CommonStyles.ml_12}>
            Personal Details
          </Text>
        </View>
        <Text
          testID={tID('PhoneVerificationSignup-Text-Title')}
          variation="HeadlineBold28"
          color={colors.textPrimary}
          style={CommonStyles.mb_12}>
          Phone Verification
        </Text>
        <Text
          testID={tID('PhoneVerificationSignup-Text-SubTitle')}
          variation="Body1Regular"
          color={colors.textSecondary}
          style={CommonStyles.mb_4}>
          Please enter the 6-digit code sent to you at
          <Text
            testID={tID('PhoneVerificationSignup-Text-PhoneNumber')}
            variation="Body1SemiBold"
            color={colors.textPrimary}>
            {' ' + getCountryCode() + ' ' + transformPhoneForAPI(phoneNo)}
          </Text>
        </Text>
        <View
          testID={tID('PhoneVerificationSignup-View-BreadCrumbsContainer')}
          style={styles.dotContainer}>
          <BreadCrumbs
            current={1}
            total={1}
            activeColor={colors.link}
            currentPassiveColor={colors.link}
            passiveColor={colors.borderMuted}
            activeDotWidth={12}
            activeDotHeight={12}
            currentPassiveDotWidth={12}
            currentPassiveDotHeight={12}
            passiveDotWidth={12}
            passiveDotHeight={12}
            containerStyle={styles.marginLeftMinus4}
          />
          <BreadCrumbs
            current={1}
            total={2}
            activeColor={colors.link}
            currentPassiveColor={colors.link}
            passiveColor={colors.borderMuted}
            activeDotWidth={24}
            activeDotHeight={12}
            currentPassiveDotWidth={12}
            currentPassiveDotHeight={12}
            passiveDotWidth={12}
            passiveDotHeight={12}
            containerStyle={styles.doubleDot}
            rightDotStyle={styles.marginTopMinus3}
          />
        </View>
        <Divider />
        <VerifyCode
          ref={codeInputRef}
          phoneNo={phoneNo}
          type={SEND_OTP_TYPES.new}
          nextScreen={isSourceApp ? 'DiabetesType' : 'ChangeTemporaryPassword'}
          needsLogin={true}
          showButtons={false}
          onCodeChange={handleCodeChange}
          onVerificationSuccess={() => moveToNextStep(isSourceApp ? 5 : 4)}
          authCredentials={authCredentials}
        />
      </ScrollView>
      <View style={styles.buttonContainer}>
        <Button
          testID={tID('PhoneVerificationSignup-Button-Resend')}
          title="Resend Code"
          titleColor={colors.link}
          style={styles.resendButton}
          onPress={() => codeInputRef?.current?.resend(phoneNo)}
        />
        <Button
          testID={tID('PhoneVerificationSignup-Button-Verify')}
          onPress={codeInputRef?.current?.verify}
          title="Verify Code"
          buttonType={BUTTON_TYPES.Filled}
          titleColor={colors.textOnAccent}
          style={styles.verifyButton}
          disabled={code.length != 6}
        />
      </View>
    </SafeAreaView>
  );
};

export default UI;
